import moment from "moment-timezone";

const TIMEZONE = "America/Phoenix"; // MST (no daylight saving time)
const DISPLAY_FORMAT = "ddd, MMM D, YYYY hh:mm A [MST]";
const DATETIME_FORMAT = "YYYY-MM-DD HH:mm";

export function convertToMST(dateTime) {
  if (!dateTime) return "-";
  return moment(dateTime).tz(TIMEZONE).format(DISPLAY_FORMAT);
}

export function nowInMST() {
  return moment().tz(TIMEZONE);
}

export function formatForSubmission(momentObj) {
  if (!momentObj) return "";
  // The DatePicker displays MST time (defaultValue is nowInMST), so the user
  // picks a date/time intending it to be MST. However, if the user's local
  // timezone differs, the antd DatePicker may create a moment in local time.
  // We take the raw date/time values (year, month, day, hour, minute) as the
  // user selected them and explicitly construct a moment in MST to ensure the
  // stored value represents the intended MST time.
  const m = moment(momentObj);
  const mstMoment = moment.tz(
    {
      year: m.year(),
      month: m.month(),
      date: m.date(),
      hour: m.hour(),
      minute: m.minute(),
      second: m.second(),
    },
    TIMEZONE
  );
  return mstMoment.format();
}

export { TIMEZONE, DATETIME_FORMAT };
